<!--
Displays a wait/loading spinner.
Usage:
  HTML:
    <Spinner ref="spinner_ref" />
  JavaScript:
    const spinner_ref = ref(null)
    spinner_ref.spin()
    spinner_ref.stop()
@author bmk11u | crm4f
-->
<template>
  <div id="spinner" class="text-center pl-5 pr-5" v-if="show">
    <div class="alert alert-light border">
      <div class="spinner-grow text-info" role="status"></div>
      <div>Please wait...</div>
    </div>
  </div>
</template>

<script setup>
import {ref, defineExpose} from 'vue'

const show = ref(false)

function spin () {
  show.value = true
}

function stop () {
  show.value = false
}

defineExpose({
  spin,
  stop
})
</script>

<style scoped lang="scss">
#spinner {
  position:absolute;
  top: 40%;
  left:1%;
  right:1%;
  margin-left:auto;
  margin-right:auto;
  z-index: 2000;
  width: 60%;
 }
</style>
